<template>
  <div class="navbar">
    <!-- <div style="padding: 0 15px" @click="toggle">
      <svg
        :class="{ 'is-active': isActive }"
        class="hamburger"
        viewBox="0 0 1024 1024"
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
      >
        <path
          d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
        />
      </svg>
    </div> -->

    <div class="right-menu">
      <el-dropdown trigger="click" @command="handleToggleRole">
        <span class="el-dropdown-link">
          {{ role }},您好！<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="a">退出登录</el-dropdown-item>
          <!-- <el-dropdown-item command="b">一般管理员</el-dropdown-item>
          <el-dropdown-item command="c">学生</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <div class="back-btn" @click="$router.push('/flyer/xg/config')">返回</div> -->
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/EventBus";
import { mapState } from 'vuex';
export default {
  data() {
    return {
      isActive: true,
      role: "",
    };
  },
  computed:{
    ...mapState('dic',['SUCCESS_CODE'])
  },
  created() {
    this.role = JSON.parse(localStorage.getItem("userInfo")).name;
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive;
      this.$emit("toggleSideBar", !this.isActive);
    },
    handleToggleRole(command) {
      // EventBus.$emit("toggleRole", command);
      // sessionStorage.setItem("role", command);
      switch (command) {
        case "a":
          // this.handleLogout();
          localStorage.clear();
          this.$router.replace('/login')
          break;
      }
    },
    handleLogout(){
      this.$http.get('/account/sys/user/logout').then(res => {
        if(res.code == this.SUCCESS_CODE) {
          localStorage.clear();
          this.$router.replace('/login')
        }
      })
    }
  },
};
</script>

